/**
 * Maps approval form field names to the Cognito groups eligible for selection.
 */
export const APPROVAL_ROLE_FILTER = {
  approvalsAssigned: ['QA'],
  approvalsOwner: ['ProcessOwner'],
  approvalsPersonnel: ['Management'],
  qmrQa: ['QA'],
  processOwners: ['ProcessOwner'],
  managementApprovers: ['Management'],
};

/**
 * Filter users by the allowed groups for a given approval field.
 * Returns all users if no filter is defined for the field name.
 */
export function filterUsersByRole(users, fieldName) {
  const allowedGroups = APPROVAL_ROLE_FILTER[fieldName];
  if (!allowedGroups) return users;
  return users.filter((u) => u.groups?.some((g) => allowedGroups.includes(g)));
}
